import { TablePaginationConfig } from "antd";
import { newsesApi } from "api/broadcast";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { ITableData, defaultTableData } from "models";
import { INews } from "models/broadcast";
import { ChangeEvent, useEffect, useState } from "react";

export default function useNews() {
  const { showError } = useNotificationContext();
  const { reloadNews } = useDataLoadingContext();
  const [data, setData] = useState<ITableData<INews>>(defaultTableData);

  useEffect(() => {
    fetchData();
  }, [data.page, data.search, reloadNews]); // eslint-disable-line

  const fetchData = async () => {
    setData((prev) => ({ ...prev, loading: true }));
    const { data: response, error } = await newsesApi(
      data.page,
      data.per_page,
      data.search
    );
    if (response) {
      response.data = response.data.map((value) => ({
        ...value,
        key: value.id,
      }));
      setData((prev) => ({ ...prev, ...response }));
    } else showError(error!.message);
    setData((prev) => ({ ...prev, loading: false }));
  };

  const handlePageChange = ({ current }: TablePaginationConfig) => {
    if (current) setData((prev) => ({ ...prev, page: current }));
  };

  const handleSearch = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({ ...prev, search: value ?? "" }));
  };

  return { data, handlePageChange, handleSearch };
}
